<template>
  <div class="signal-page">
    <header class="header">
      <h1>全球市场波动率信号灯</h1>
      <p>实时监测主要资本市场的波动情况，助你把握市场脉搏</p>
    </header>

    <main class="main">
      <div class="market-grid">
        <MarketSignal
          v-for="market in markets"
          :key="market.id"
          :market-id="market.id"
          :name="market.name"
        />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MarketSignal from '@/components/MarketSignal.vue'

const markets = ref([
  {
    id: 'CN',
    name: '中国市场'
  },
  {
    id: 'US',
    name: '美国市场'
  }
])
</script>

<style scoped>
.signal-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
  padding: 2rem;
}

.header {
  text-align: center;
  margin-bottom: 3rem;
}

.header h1 {
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.header p {
  color: #9ca3af;
}

.market-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  max-width: 512px;
  margin: 0 auto;
}
</style>

